<template>
    <div>
        <Header title="用户分组" memo="管理测评用户所属分组信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div>
                <a-button type="primary" icon="plus" @click="showAddForm" :style="{ marginRight: '8px' }">
                    添加
                </a-button>

                <a-button type="danger" icon="delete" @click="execDelete" :style="{ marginRight: '8px' }" :disabled="selRows.length === 0">
                    删除
                </a-button>
            </div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="datas" :loading="loading" :row-selection="{ type: 'checkbox', onChange: onSelectChange }" bordered :pagination="false">
            <a-table-column key="name" ellipsis width="300px">
                <span slot="title">分组名称</span>
                <template slot-scope="text, record">
                    <span>
                        {{ record.name }}
                    </span>
                </template>
            </a-table-column>
            <a-table-column key="memo" ellipsis>
                <span slot="title">分组描述</span>
                <template slot-scope="text, record">
                    <span>
                        {{ record.memo }}
                    </span>
                </template>
            </a-table-column>
            <a-table-column key="count" ellipsis width="200px">
                <span slot="title">用户人数</span>
                <template slot-scope="text, record">
                    <span>{{ record.count }} 人</span>
                </template>
            </a-table-column>
            <a-table-column key="action" fixed width="200px">
                <span slot="title">操作</span>
                <template slot-scope="text, record">
                    <a-button type="link" icon="edit" @click="showEditForm(record)">
                        编辑
                    </a-button>
                    <a-popconfirm :title="'是否删除分组[' + record.name + ']，删除后无法恢复'" ok-type="danger" ok-text="确认删除" cancel-text="取消" @confirm="doDelete(record.id)">
                        <a-button type="link" icon="delete">
                            删除
                        </a-button>
                    </a-popconfirm>
                </template>
            </a-table-column>
        </a-table>

        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />

        <FormComp title="编辑用户分组" :item="now" :show.sync="form" v-if="form" @doLoad="doLoad"></FormComp>
    </div>
</template>

<script>
import FormComp from './FormComp'

export default {
    name: 'AteUnitOrg',
    components: {
        FormComp
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        },
        rowSelection() {
            return {
                onChange: this.onSelectRows
            }
        }
    },
    data() {
        return {
            query: {
                page: 1,
                size: 10,
                time: 0
            },
            selRows: [],
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            },
            view: false,
            reset: false,
            form: false,
            now: {}
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['云测评', '用户分组'])
        this.doLoad()
    },
    methods: {
        doLoad() {
            this.$http
                .get('/cts/ate/tester/org/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },
        doDelete(ids) {
            this.$http
                .post('/cts/ate/tester/org/delete', {
                    ids: typeof ids === 'string' ? ids : ids.join()
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('删除成功')
                        this.doLoad()
                    }
                })
        },

        onSelectChange(selectedRowKeys, selectedRows) {
            this.selRows = selectedRows
        },
        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.query = {
                page: 1,
                size: 10,
                time: 0
            }
            this.doLoad()
        },
        showAddForm() {
            this.now = {}
            this.form = true
        },
        showEditForm(item) {
            this.now = item
            this.form = true
        },

        execDelete() {
            let names = []
            let ids = []
            this.selRows.forEach(row => {
                names.push(row.name)
                ids.push(row.id)
            })
            if (ids.length === 0) {
                this.$message.error('请选择要删除的组织')
                return
            }
            this.$confirm({
                title: '是否删除以下组织？删除后无法恢复。',
                content: '组织：[' + names.join() + ']',
                okText: '确认删除',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doDelete(ids)
                }
            })
        }
    }
}
</script>
